import { CheckCircleIcon } from "@heroicons/react/24/solid"

import { Bee } from "~/src/components/BeeKit"
import { iClient } from "~/src/lib/appClients"

const ERROR_EVENT = "tray.authpopup.error"
const CLOSE_EVENT = "tray.authpopup.close"
const FINISH_EVENT = "tray.authpopup.finish"

type AuthenticationFieldProps = {
  externalId: string
  solutionInstanceId: number
  title: string
  value: string | null | undefined
  onChange?: (newAuthId: string) => void
}

export function AuthenticationField({
  externalId,
  solutionInstanceId,
  title,
  value,
  onChange,
}: AuthenticationFieldProps) {
  const handleClick = () => {
    ;(async () => {
      try {
        const {
          data: { url: dialogUrl },
        } = await iClient.get(`/tray_io/solution_instances/${solutionInstanceId}/authentications/dialog_url`, {
          params: { external_auth_id: externalId },
        })
        const dialogWindow = window.open(undefined, "_blank", "width=500,height=500,scrollbars=no") // do not load until ready

        const cleanup = () => {
          dialogWindow?.close()
          window.removeEventListener("message", onMessage)
        }
        const onMessage = (event: MessageEvent) => {
          switch (event.data.type.toLowerCase()) {
            case ERROR_EVENT: {
              console.error("API error: " + event.data.error)
              cleanup()
              break
            }
            case CLOSE_EVENT: {
              console.trace("User closed the auth dialog")
              cleanup()
              break
            }
            case FINISH_EVENT: {
              console.trace("Auth process complete")
              cleanup()
              onChange && onChange(event.data.authId)
              break
            }
          }
        }

        window.addEventListener("message", onMessage)
        dialogWindow?.location?.assign(dialogUrl)
      } catch (error) {
        console.error(error)
      }
    })()
  }

  return (
    <Bee.Button key={externalId} type="button" onClick={handleClick}>
      {value == null || value == "" ? (
        <span>Connect to {title}</span>
      ) : (
        <>
          <CheckCircleIcon className="mr-2 inline-block h-4 w-4" />
          <span>Connected to {title}</span>
        </>
      )}
    </Bee.Button>
  )
}
